import { render, staticRenderFns } from "./_ProductYearDialog.vue?vue&type=template&id=47c6c5fc"
import script from "./_ProductYearDialog.vue?vue&type=script&lang=js"
export * from "./_ProductYearDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports